import { Component, OnInit, OnDestroy } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DataService } from "src/app/services/data.service";
import { ToastrService } from "ngx-toastr";
import { Subscription } from "rxjs";

@Component({
  selector: "app-formula-config",
  templateUrl: "./formula-config.component.html",
  styleUrls: ["./formula-config.component.scss"],
})
export class FormulaConfigComponent implements OnInit, OnDestroy {
  availabilityNumerator: { [key: string]: boolean } = {};
  availabilityDenominator: { [key: string]: boolean } = {};
  performanceNumerator: { [key: string]: boolean } = {};
  // performanceDenominator: { [key: string]: boolean } = {};
  breadCrumbItems: Array<{}>;
  formError: string = "";
  formError2: string = "";
  private subscriptions: Subscription[] = [];
  id: any = "";
  selectedconfigType = "parts";
  custId: any = "";
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private dataservice: DataService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.custId = this.route.snapshot.paramMap.get("id");
    this.loadConfigFromApi();
    this.breadCrumbItems = [
      { label: "Configuration" },
      { label: "Device" },
      { label: "Formula", active: true },
    ];
  }
   configtypeChange(e) {
    this.selectedconfigType = e;
    this.loadConfigFromApi();
  }

  loadConfigFromApi(): void {
    const subscription = this.dataservice
      .get(
        `formula?custId=${this.custId}&configType=${this.selectedconfigType}`
      )
      .subscribe(
        (res: any) => {
          if (res) {
            this.id = res["id"];
            if (this.selectedconfigType == "parts") {
              this.availabilityNumerator = res["availabilityNumerator"];
              this.availabilityDenominator = res["availabilityDenominator"];
            } else if (this.selectedconfigType == "noparts") {
              this.availabilityNumerator = res["availabilityNumerator"];
              this.availabilityDenominator = res["availabilityDenominator"];
              this.performanceNumerator = res["performanceNumerator"];
              // this.performanceDenominator = res["performanceDenominator"];
            } else if (this.selectedconfigType == "cycletime") {
              this.availabilityNumerator = res["availabilityNumerator"];
              this.availabilityDenominator = res["availabilityDenominator"];
            }
          }
        },
        (error) => {
          this.toastr.error("Server Unreachable");
        }
      );
    this.subscriptions.push(subscription);
  }


  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  // get availformula(): string {
  //   const nominator = Object.keys(this.availabilityNumerator).filter(
  //     (key) => this.availabilityNumerator[key]
  //   );
  //   const denominator = Object.keys(this.availabilityDenominator).filter(
  //     (key) => this.availabilityDenominator[key]
  //   );

  //   return `Availability = ((${nominator.join(" - ")}) / (${denominator.join(
  //     " - "
  //   )})) × 100`;
  // }
  get availformulaNumerator(): string {
    const nominator = Object.keys(this.availabilityNumerator).filter(
      (key) => this.availabilityNumerator[key]
    );
    return `(${nominator.join(" - ")})`;
  }
  get availformulaDenominator(): string {
    const denominator = Object.keys(this.availabilityDenominator).filter(
      (key) => this.availabilityDenominator[key]
    );
    return `(${denominator.join(" - ")})`;
  }
  get perfformula(): string {
    const nominator = Object.keys(this.performanceNumerator).filter(
      (key) => this.performanceNumerator[key]
    );
    // const denominator = Object.keys(this.performanceDenominator).filter(
    //   (key) => this.performanceDenominator[key]
    // );
    if (this.selectedconfigType == "noparts") {
      return `${nominator.join(" - ")}`;
    } else if (this.selectedconfigType == "cycletime") {
      return `Performance = (Part Produced / (${nominator.join(
        " - "
      )} / CycleTime )) × 100`;
    }
  }
  openModalRest(temp) {
         console.log("came inside",this.selectedconfigType)
    if (this.selectedconfigType == "parts") {
      const hasNominator = Object.values(this.availabilityNumerator).some(
        (v) => v === true
      );
      const hasDenominator = Object.values(this.availabilityDenominator).some(
        (v) => v === true
      );

      if (!hasNominator || !hasDenominator) {
        this.formError =
          "Please select at least one parameter for both Nominator and Denominator.";
        return;
      }
      this.formError = "";
      this.modalService.open(temp, { backdrop: "static", centered: true });
    } else if (this.selectedconfigType == "noparts") {
      const hasavailNominator = Object.values(this.availabilityNumerator).some(
        (v) => v === true
      );
      const hasavailDenominator = Object.values(
        this.availabilityDenominator
      ).some((v) => v === true);
      if (!hasavailNominator || !hasavailDenominator) {
        this.formError =
          "Please select at least one parameter for both Nominator and Denominator.";
        return;
      }
      const hasperfNominator = Object.values(this.performanceNumerator).some(
        (v) => v === true
      );
      // const hasperfDenominator = Object.values(
      //   this.performanceDenominator
      // ).some((v) => v === true);
      if (!hasperfNominator) {
        this.formError2 =
          "Please select at least one parameter for both Nominator and Denominator.";
        return;
      }
      this.formError = "";
      this.formError2 = "";
      this.modalService.open(temp, { backdrop: "static", centered: true });
    } else if (this.selectedconfigType == "cycletime") {
      console.log("came inside2",this.selectedconfigType)
      const hasavailNominator = Object.values(this.availabilityNumerator).some(
        (v) => v === true
      );
      const hasavailDenominator = Object.values(
        this.availabilityDenominator
      ).some((v) => v === true);
      if (!hasavailNominator || !hasavailDenominator) {
        this.formError =
          "Please select at least one parameter for both Nominator and Denominator.";
        return;
      }
      // const hasperfNominator = Object.values(this.performanceNumerator).some(
      //   (v) => v === true
      // );
      // if (!hasperfNominator) {
      //   this.formError2 = "Please select at least one parameter for Nominator.";
      //   return;
      // }
      this.formError = "";
      // this.formError2 = "";

      this.modalService.open(temp, { backdrop: "static", centered: true });
    }
  }
  onSubmit(): void {
    if (this.selectedconfigType == "parts") {
      const payload = {
        configType: this.selectedconfigType,
        availabilityNumerator: this.availabilityNumerator,
        availabilityDenominator: this.availabilityDenominator,
      };
      const subscription = this.dataservice
        .put(`formula/${this.id}`, payload)
        .subscribe(
          (res) => {
            if (res) {
              this.toastr.success("Formula changed", "Success");
              this.loadConfigFromApi();
            }
          },
          (error) => {
            if (error == "Server Unreachable")
              this.toastr.error("Server Unreachable", "Error");
            else this.toastr.error(error, "Error");
          }
        );
      this.subscriptions.push(subscription);
      console.log("Payload to send:", payload);
    } else if (this.selectedconfigType == "noparts") {
      const payload = {
        configType: this.selectedconfigType,
        availabilityNumerator: this.availabilityNumerator,
        availabilityDenominator: this.availabilityDenominator,
        performanceNumerator: this.performanceNumerator
      };
      const subscription = this.dataservice
        .put(`formula/${this.id}`, payload)
        .subscribe(
          (res) => {
            if (res) {
              this.toastr.success("Formula changed", "Success");
              this.loadConfigFromApi();
            }
          },
          (error) => {
            if (error == "Server Unreachable")
              this.toastr.error("Server Unreachable", "Error");
            else this.toastr.error(error, "Error");
          }
        );
      this.subscriptions.push(subscription);
      console.log("Payload to send:", payload);
    } else if (this.selectedconfigType == "cycletime") {
      const payload = {
        configType: this.selectedconfigType,
        availabilityNumerator: this.availabilityNumerator,
        availabilityDenominator: this.availabilityDenominator,
      };
      const subscription = this.dataservice
        .put(`formula/${this.id}`, payload)
        .subscribe(
          (res) => {
            if (res) {
              this.toastr.success("Formula changed", "Success");
              this.loadConfigFromApi();
            }
          },
          (error) => {
            if (error == "Server Unreachable")
              this.toastr.error("Server Unreachable", "Error");
            else this.toastr.error(error, "Error");
          }
        );
      this.subscriptions.push(subscription);
      console.log("Payload to send:", payload);
    }
    this.modalService.dismissAll();
  }
  goBack() {
    this.router.navigate(["/device", { id: this.custId }]);
  }
  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
  }
}
